import alt from '../alt'

class MobileActions {
  constructor () {
    this.generateActions('showBackButton', 'hideBackButton')
  }
}

module.exports = alt.createActions(MobileActions)



// WEBPACK FOOTER //
// ./src/actions/MobileActions.js